const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const VersionAdd = () => import(/* webpackChunkName: "version" */ '@/modules/version/view/add.vue');
const VersionEdit = () => import(/* webpackChunkName: "version" */ '@/modules/version/view/edit.vue');
const Version = () => import(/* webpackChunkName: "version" */ '@/modules/version/view/index.vue');

export const ROUTE_NAME_VERSION = {
    INDEX: 'VersionList',
    ADD: 'VersionAdd',
    EDIT: 'VersionEdit'
} as const;

export default [
    {
        path: '/app/:appId/version',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: '',
                name: ROUTE_NAME_VERSION.INDEX,
                component: Version,
                meta: { requiresAuth: true }
            },
            {
                path: 'add',
                name: ROUTE_NAME_VERSION.ADD,
                component: VersionAdd,
                meta: { requiresAuth: true }
            },
            {
                path: ':id',
                name: ROUTE_NAME_VERSION.EDIT,
                component: VersionEdit,
                meta: { requiresAuth: true }
            }
        ]
    }
];
